export const API_URL = process.env.REACT_APP_API_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getApiUrl = (endpoint) => {
  if (!endpoint) return "";

  if (endpoint.startsWith("http")) return endpoint;

  if (endpoint.includes("/uploads/") || endpoint.includes("/images/")) {
    return `${BASE_URL}${endpoint}`;
  }

  return API_URL.includes("?url=")
    ? `${API_URL}${endpoint}`
    : `${API_URL}/${endpoint}`;
};
